<template>
  <div class="master-material-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong>{{ $t('edit') }}</strong>
              <div class="card-actions">
              </div>
            </div>
            <b-form class="row" v-if="item.id != null">
              <b-col cols="9" align-self="center">
                <b-form-group v-bind:label="$t('group_id')" :label-cols="3" :horizontal="true">
                  <v-select v-model="item.group_id" :options="groups" :disabled="id">
                  </v-select>
                </b-form-group>
                <b-form-group v-bind:label="$t('type')" :label-cols="3" :horizontal="true">
                  <v-select v-model="item.type_id" :options="types":disabled="id">
                  </v-select>
                </b-form-group>
                <b-form-group v-bind:label="$t('account_code')" :label-cols="3" :horizontal="true">
                  <v-select v-model="item.account_id" :options="accounts">
                  </v-select>
                </b-form-group>
                <b-form-group v-bind:label="$t('genstore_code')" :label-cols="3" :horizontal="true">
                  <v-select v-model="item.genstore_id" :options="genstores">
                  </v-select>
                </b-form-group>
                <b-form-group v-bind:label="$t('material_code')" :label-cols="3" :horizontal="true">
                  <b-form-input class="form-control" v-model="item.code">
                  </b-form-input>
                </b-form-group>
                <b-form-group v-bind:label="$t('material_name')" :label-cols="3" :horizontal="true">
                  <b-form-input class="form-control" v-model="item.name">
                  </b-form-input>
                </b-form-group>
                <b-form-group v-bind:label="$t('net_weight')" :label-cols="3" :horizontal="true">
                  <b-form-input class="form-control" type="number" v-model="item.recipe_rate">
                  </b-form-input>
                </b-form-group>
                <b-form-group v-bind:label="$t('material_uom')" :label-cols="3" :horizontal="true">
                  <v-select v-model="item.recipe_rate_uom_id" :options="uoms">
                  </v-select>
                </b-form-group>
                <b-form-group v-bind:label="$t('active')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}"
                            v-model="item.is_active" v-bind:checked="item.is_active" :value="1" :uncheckedValue="0"/>
                </b-form-group>

              </b-col>
            </b-form>
            <div slot="footer" class="text-center">
              <router-link :to="{name: model + '_list'}">
                <b-button variant="default"><i class="fa fa-arrow-left"></i> {{$t('back')}}</b-button>
              </router-link>
<!--              <b-button variant="success" v-on:click="updateItem" v-if="id != null && $auth.check(model + '.update')"><i-->
              <b-button variant="success" v-on:click="updateItem" v-if="id != null"><i
                class="fa fa-save"></i> {{$t('update')}}
              </b-button>
<!--              <b-button variant="success" v-on:click="createItem" v-if="id == null && $auth.check(model + '.create')"><i-->
              <b-button variant="success" v-on:click="createItem" v-if="id == null"><i
                class="fa fa-save"></i> {{$t('save')}}
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
  import cSwitch from '../../../../components/Switch'
  import {
    generateCode,
    get,
    create,
    update
  } from '@/api/master_material'
  import {getMasterGroupList} from '@/api/master_group'
  import {getMasterTypeList} from '@/api/master_type'
  import {getMasterAccountList} from '@/api/master_account'
  import {getMasterGenstoreList} from '@/api/master_genstore'
  import {getMasterUomList} from '@/api/master_uom'

  export default {
    name: 'MasterMaterialForm',
    props: {
      id: {
        default: null
      }
    },
    components: {
      cSwitch
    },
    computed: {},
    data: function () {
      return {
        model: 'master_material',
        item: {
          id: null,
          group_id: '',
          type_id: '',
          account_id: '',
          genstore_id: '',
          code: '',
          name: '',
          recipe_rate: '',
          recipe_rate_uom_id: '',
          is_active: 1
        },
        languages: Object.keys(this.$i18n.messages),
        groups: [],
        types: [],
        accounts: [],
        genstores: [],
        uoms: []
      }
    },
    methods: {
      /**
       * Get List Uom
       */
      getListUom() {
        this.$Progress.start()
        getMasterUomList().then((response) => {
          for (let i in response.data.data) {
            this.uoms.push({
              label: response.data.data[i].name,
              value: response.data.data[i].id,
            })
          }
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },
      /**
       * Get List Group
       */
      getListGroup() {
        this.$Progress.start()
        getMasterGroupList().then((response) => {
          for (let i in response.data.data) {
            this.groups.push({
              label: response.data.data[i].name,
              value: response.data.data[i].id,
              code: response.data.data[i].code
            })
          }
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },

      /**
       * Get List Account
       */
      getListType() {
        this.$Progress.start()
        getMasterTypeList().then((response) => {
          for (let i in response.data.data) {
            this.types.push({
              label: response.data.data[i].name,
              value: response.data.data[i].id,
              code: response.data.data[i].code
            })
          }
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },

      /**
       * Get List Account
       */
      getListAccount() {
        this.$Progress.start()
        getMasterAccountList().then((response) => {
          for (let i in response.data.data) {
            this.accounts.push({
              label: response.data.data[i].code,
              value: response.data.data[i].id
            })
          }
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },

      /**
       * Get List Genstore
       */
      getListGenstore() {
        this.$Progress.start()
        getMasterGenstoreList().then((response) => {
          for (let i in response.data.data) {
            this.genstores.push({
              label: response.data.data[i].code,
              value: response.data.data[i].id
            })
          }
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },

      /**
       * Get details of object
       */
      getDetails() {
        this.$Progress.start()
        let params = {
          id: this.id
        }
        get(params).then((response) => {
          this.item = response.data.data
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },

      /**
       * Update item info to server
       */
      updateItem() {
        this.$Progress.start()
        let param = Object.assign({}, this.item)
        param.group_id = this.item.group_id.value
        param.type_id = this.item.type_id.value
        param.account_id = this.item.account_id.value
        param.genstore_id = this.item.genstore_id.value
        param.recipe_rate_uom_id = this.item.recipe_rate_uom_id.value
        update(param).then((response) => {
          this.$notify({
            title: this.$t('success'),
            text: response.data.message,
            type: 'success'
          })
          this.$router.push({name: this.model})
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },

      /**
       * Create item info to server
       */
      createItem() {
        this.$Progress.start()
        let param = Object.assign({}, this.item)
        param.group_id = this.item.group_id.value
        param.type_id = this.item.type_id.value
        param.account_id = this.item.account_id.value
        param.genstore_id = this.item.genstore_id.value
        param.recipe_rate_uom_id = this.item.recipe_rate_uom_id.value
        create(param).then((response) => {
          this.$notify({
            title: this.$t('success'),
            text: response.data.message,
            type: 'success'
          })
          this.$router.push({name: this.model})
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },

      /**
       * Generate material code from server
       */
      generateMaterialCode() {
        if (this.item.group_id.value && this.item.type_id.value) {
          let params = {
            group_id: this.item.group_id.value,
            group_code: this.getGroupCode(),
            type_id: this.item.type_id.value,
            type_code: this.getTypeCode()
          }
          generateCode(params).then((response) => {
            this.item.code = response.data.data.material_code
          }).catch((error) => {
          })
        }
      },
      /**
       * Get group code
       */
      getGroupCode() {
        for (let i in this.groups) {
          let group = this.groups[i];
          if (group.value == this.item.group_id.value) {
            return group.code
          }
        }
      },

      /**
       * Get type code
       */
      getTypeCode() {
        for (let i in this.types) {
          let type = this.types[i]
          if (type.value == this.item.type_id.value) {
            return type.code
          }
        }
      }
    },
    created: function () {
      this.getListGroup()
      this.getListType()
      this.getListAccount()
      this.getListGenstore()
      this.getListUom()
      if (this.id != null) {
        this.getDetails()
      } else {
        this.item.id = ''
      }
    },
    watch: {
      'item.group_id': function () {
        if (this.id == null) {
          this.generateMaterialCode()
        }
      },
      'item.type_id': function () {
        if (this.id == null) {
          this.generateMaterialCode()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/admin/inventory/master_material/Form.vue